'use strict';

import $ from 'jquery';
import {Sentry} from '../Core/sentry.js';
import {browser} from '../Core/Browser.js';
import {glossar} from '../Core/Glossar.js';
import {i18n} from './Core/i18n.js';
import {createRoot} from 'react-dom/client';
import React from 'react';
import {Survey} from './components/Survey/Survey.js';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {PollProvider} from '../Common/React/lib/contexts/PollContext.js';

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import '../Common/Styles/_froala.scss';

Sentry.configureScope(scope => scope.setTag('interface', 'survey'));

window.Browser = browser;
window.Glossar = glossar;
window.translate = i18n.t;
window.Sentry = Sentry;

$(() => {
    const accId = document.getElementById('poll').getAttribute('accId');
    Sentry.configureScope(scope => scope.setTag('account', accId));
    window.LP.initRespondend();
});

const rootElement = createRoot(document.getElementById('survey-react-root'));
const pollId = document.getElementById('poll').getAttribute('data-survey-id');
const queryClient = new QueryClient();

rootElement.render(
    <QueryClientProvider client={queryClient}>
        <PollProvider pollId={pollId}>
            <Survey/>
        </PollProvider>
    </QueryClientProvider>);